import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IDispatch, IDispatchVerify, IVerifyPayload } from 'modules/sales/dispatch/interfaces';
import { DISPATCH_STATUS_ENUM } from '../constants/dispatch.enum';

class DispatchService extends EntityApiService<IDispatch> {
  verify = (payload: IVerifyPayload): Promise<IDispatchVerify> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/verify'), payload));
  };

  add = (dispatchId: string | null, params: any) => {
    if (dispatchId) {
      return this.handleResponse(ApiClientService.post(this.getPath('/add-suborders'), { ...params, dispatchId }));
    }
    throw new Error('required dispatchId');
  };

  remove = (dispatchId: string, filters: any) => {
    return this.handleResponse(
      ApiClientService.post(this.getPath('/remove-suborders'), {
        dispatchId,
        filters,
      }),
    );
  };

  searchProducts = (dispatchId: string, params?: any, config?: RequestConfig): any => {
    const size = params?.size === 10 ? 16 : params?.size;
    if (dispatchId) {
      return this.handleSearchResponse(
        ApiClientService.post(this.getPath(`/${dispatchId}/products`), { ...params, dispatchId }, config),
        size,
      );
    }
    throw new Error('required dispatchId');
  };

  searchWarehouses = (dispatchId: string, params?: any, config?: RequestConfig): any => {
    const size = params?.size === 10 ? 16 : params?.size;
    if (dispatchId) {
      return this.handleSearchResponse(
        ApiClientService.post(this.getPath(`/${dispatchId}/warehouses`), { ...params, dispatchId }, config),
        size,
      );
    }
    throw new Error('required dispatchId');
  };

  start = (dispatchId: string | null) => {
    if (dispatchId) {
      return this.handleResponse(ApiClientService.post(this.getPath(`/${dispatchId}/start`), null));
    }
    throw new Error('required dispatchId');
  };

  packingList = (dispatchId: string | null, warehouseId: string) => {
    if (dispatchId && warehouseId) {
      return this.handleResponse(
        ApiClientService.post(this.getPath(`/${dispatchId}/warehouse/${warehouseId}/download`), null),
      );
    }
    throw new Error('required dispatchId and warehouseId');
  };

  updateStatus = (id: string, status: DISPATCH_STATUS_ENUM) => {
    return ApiClientService.patch(this.getPath(`/${id}/${status}`), status);
  };
}

export default new DispatchService('/ms-sales/api/dispatch');
